"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleiTunesSearchResultsSchema = exports.AppleiTunesLookupResultsSchema = exports.AppleiTunesResultResponseSchema = exports.AppleiTunesFindQuerySchema = exports.AppleiTunesLookupQueryParamsSchema = exports.AppleiTunesLookupParamsSchema = exports.AppleiTunesSearchResultSchema = exports.AppleiTunesMacSoftwareSearchResultSchema = exports.AppleiTunesSoftwareResultSchema = void 0;
// See https://github.com/fvdm/nodejs-searchitunes
// Seems to work from the quick test but has no types
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.AppleiTunesSoftwareResultSchema = typebox_1.Type.Object({
    ipadScreenshotUrls: core_1.UrlsSchema,
    appletvScreenshotUrls: core_1.UrlsSchema,
    artworkUrl60: core_1.UrlSchema,
    artworkUrl512: core_1.UrlSchema,
    artworkUrl100: core_1.UrlSchema,
    artistViewUrl: core_1.UrlSchema,
    screenshotUrls: core_1.UrlsSchema,
    isGameCenterEnabled: typebox_1.Type.Boolean(),
    features: typebox_1.Type.Array(typebox_1.Type.String()),
    supportedDevices: typebox_1.Type.Array(typebox_1.Type.String()),
    advisories: typebox_1.Type.Array(typebox_1.Type.String()),
    kind: typebox_1.Type.String(),
    minimumOsVersion: typebox_1.Type.String(),
    trackCensoredName: typebox_1.Type.String(),
    languageCodesISO2A: typebox_1.Type.Array(typebox_1.Type.String()),
    fileSizeBytes: typebox_1.Type.String(),
    sellerUrl: typebox_1.Type.Optional(core_1.UrlSchema),
    formattedPrice: typebox_1.Type.String(),
    contentAdvisoryRating: typebox_1.Type.String(),
    averageUserRatingForCurrentVersion: typebox_1.Type.Number(),
    userRatingCountForCurrentVersion: typebox_1.Type.Number(),
    averageUserRating: typebox_1.Type.Number(),
    trackViewUrl: core_1.UrlSchema,
    trackContentRating: typebox_1.Type.String(),
    releaseDate: typebox_1.Type.String(),
    bundleId: typebox_1.Type.String(),
    trackId: ruby_1.AppleProxyRefSchema,
    trackName: typebox_1.Type.String(),
    sellerName: typebox_1.Type.String(),
    primaryGenreName: typebox_1.Type.String(),
    genreIds: typebox_1.Type.Array(typebox_1.Type.String()),
    isVppDeviceBasedLicensingEnabled: typebox_1.Type.Boolean(),
    currentVersionReleaseDate: typebox_1.Type.String(),
    releaseNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    primaryGenreId: typebox_1.Type.Number(),
    currency: typebox_1.Type.String(),
    version: typebox_1.Type.String(),
    wrapperType: typebox_1.Type.String(),
    artistId: ruby_1.AppleProxyRefSchema,
    artistName: typebox_1.Type.String(),
    genres: typebox_1.Type.Array(typebox_1.Type.String()),
    price: typebox_1.Type.Number(),
    description: typebox_1.Type.String(),
    userRatingCount: typebox_1.Type.Number(),
});
exports.AppleiTunesMacSoftwareSearchResultSchema = typebox_1.Type.Object({
    artistId: ruby_1.AppleProxyRefSchema,
    artistName: typebox_1.Type.String(),
    artistViewUrl: core_1.UrlSchema,
    artworkUrl100: core_1.UrlSchema,
    artworkUrl512: core_1.UrlSchema,
    artworkUrl60: core_1.UrlSchema,
    averageUserRating: typebox_1.Type.Number(),
    averageUserRatingForCurrentVersion: typebox_1.Type.Number(),
    bundleId: typebox_1.Type.String(),
    contentAdvisoryRating: typebox_1.Type.String(),
    currency: typebox_1.Type.String(),
    currentVersionReleaseDate: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    fileSizeBytes: typebox_1.Type.String(),
    formattedPrice: typebox_1.Type.String(),
    genreIds: typebox_1.Type.Array(typebox_1.Type.String()),
    genres: typebox_1.Type.Array(typebox_1.Type.String()),
    isVppDeviceBasedLicensingEnabled: typebox_1.Type.Boolean(),
    kind: typebox_1.Type.String(),
    languageCodesISO2A: typebox_1.Type.Array(typebox_1.Type.String()),
    minimumOsVersion: typebox_1.Type.String(),
    price: typebox_1.Type.Number(),
    primaryGenreId: ruby_1.AppleProxyRefSchema,
    primaryGenreName: typebox_1.Type.String(),
    releaseDate: typebox_1.Type.String(),
    releaseNotes: typebox_1.Type.Optional(typebox_1.Type.String()),
    screenshotUrls: core_1.UrlsSchema,
    sellerName: typebox_1.Type.String(),
    sellerUrl: typebox_1.Type.Optional(core_1.UrlSchema),
    trackCensoredName: typebox_1.Type.String(),
    trackContentRating: typebox_1.Type.String(),
    trackId: ruby_1.AppleProxyRefSchema,
    trackName: typebox_1.Type.String(),
    trackViewUrl: core_1.UrlSchema,
    userRatingCount: typebox_1.Type.Number(),
    userRatingCountForCurrentVersion: typebox_1.Type.Number(),
    version: typebox_1.Type.String(),
    wrapperType: typebox_1.Type.String(),
});
// Also have movies, etc... but I think we can scope to software
exports.AppleiTunesSearchResultSchema = typebox_1.Type.Intersect([
    exports.AppleiTunesSoftwareResultSchema,
    exports.AppleiTunesMacSoftwareSearchResultSchema,
]);
exports.AppleiTunesLookupParamsSchema = (0, core_1.StrictObject)({
    id: ruby_1.AppleProxyRefSchema,
});
exports.AppleiTunesLookupQueryParamsSchema = (0, core_1.StrictObject)({
    country: typebox_1.Type.Optional(core_1.CountrySchema),
});
exports.AppleiTunesFindQuerySchema = (0, core_1.StrictObject)({
    query: core_1.SearchStringSchema,
    country: typebox_1.Type.Optional(core_1.CountrySchema),
});
exports.AppleiTunesResultResponseSchema = (0, core_1.createUnsortedListResponseSchema)(
// In theory: AppleiTunesSearchResultSchema
(0, core_1.JSONObject)({}, {}));
exports.AppleiTunesLookupResultsSchema = typebox_1.Type.Object({
    resultCount: core_1.CountSchema,
    results: typebox_1.Type.Array(exports.AppleiTunesSearchResultSchema),
});
exports.AppleiTunesSearchResultsSchema = typebox_1.Type.Object({
    resultCount: core_1.CountSchema,
    results: typebox_1.Type.Array(exports.AppleiTunesSearchResultSchema),
});
